const trig = (s) => s.triggered !== false && !s.moodOnly;

// Every section of an entry, in reflection order. `guided` = opens that guided step in the reflection.
export const SECTIONS = [
  { key: "postSuds", label: "Distress now", kind: "suds", na: "Only recorded after a Get help now session", applies: (s) => s.path === "emergency", has: (s) => s.postSuds != null },
  { key: "triggered", label: "Were you triggered?", kind: "yesno", na: "Not asked for a quick mood log", applies: (s) => !s.moodOnly, has: (s) => s.triggered != null },
  { key: "moodBefore", label: "Mood as a result of the trigger", kind: "mood", applies: trig, has: (s) => s.moodBefore != null },
  { key: "triggerNote", label: "What triggered you", kind: "text", applies: trig, has: (s) => !!s.triggerNote },
  { key: "copingMode", label: "Coping mode & survival response", guided: "mode", applies: trig, has: (s) => !!s.copingMode },
  { key: "schemaState", label: "Schema state", guided: "schema", applies: trig, has: (s) => !!s.schemaState },
  { key: "moodNow", label: "Mood now", kind: "mood", applies: () => true, has: (s) => s.moodNow != null },
  { key: "needs", label: "Unmet needs", guided: "needs", applies: trig, has: (s) => !!s.needs?.length },
  { key: "emaSchemas", label: "Schemas activated", guided: "schemas", applies: trig, has: (s) => !!s.emaSchemas?.length },
  { key: "aiInsight", label: "AI reflection", guided: "insight", applies: trig, has: (s) => !!s.aiInsight },
  { key: "coping", label: "Coping used", kind: "coping", applies: trig, has: (s) => !!s.copingMechanisms?.length },
  { key: "reflectionNotes", label: "Your reflections", kind: "text", optional: true, applies: () => true, has: (s) => !!s.reflectionNotes },
];

const legacyDone = (s) => s.completed === true || (s.completed == null && (s.moodNow != null || s.triggered != null));

export function sectionStatus(s, sec) {
  if (!sec.applies(s)) return "na";
  if (sec.has(s)) return "done";
  if (sec.optional) return "optional";
  return legacyDone(s) || s.skipped?.includes(sec.key) ? "skipped" : "missing";
}

export const missingSections = (s) => SECTIONS.filter((sec) => sectionStatus(s, sec) === "missing");
export const isUnfinished = (s) => missingSections(s).length > 0;

// Adds skipped keys and flips `completed` to true once nothing is missing.
export function withCompletion(s, patch, skip = []) {
  const skipped = [...new Set([...(s.skipped ?? []), ...skip])];
  const out = skip.length ? { ...patch, skipped } : { ...patch };
  if (!isUnfinished({ ...s, ...out, skipped })) out.completed = true;
  return out;
}
